import React, { useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled from "styled-components";

import './NavMenu.css';
import AuthNav from "./AuthNav"

const Logo = styled.img`
    width: 100px;
    margin-right: 20px;
`;

//export default class NavMenu extends React.PureComponent<{}, { isOpen: boolean }> {
const NavMenu = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3" dark>
                <Container>
                    <Logo src="/images/AppMesh-logo.svg" />
                    <NavbarBrand>AppMesh</NavbarBrand>
                            {/*
                    <NavbarToggler onClick={toggle} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={isOpen} navbar>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={Link} className="text-light" to="/">Rock calculator</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/counter">Sign in</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/fetch-data">Register</NavLink>
                            </NavItem>
                            <AuthNav/>
                        </ul>
                    </Collapse>
                            */}
                </Container>
            </Navbar>
        </header>
    );
}

export default NavMenu;